import { render, staticRenderFns } from "./CajaSeleccionar.vue?vue&type=template&id=383969f2&scoped=true&"
import script from "./CajaSeleccionar.vue?vue&type=script&lang=js&"
export * from "./CajaSeleccionar.vue?vue&type=script&lang=js&"
import style0 from "./CajaSeleccionar.vue?vue&type=style&index=0&id=383969f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383969f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VIcon})
